export default{
    buildParams: function(obj){
        if (!obj) {
            return ''
          }
          const params = []
          for (const key of Object.keys(obj)) {
            const value = obj[key] === undefined ? '' : obj[key]
            params.push(`${key}=${encodeURIComponent(value)}`)
          }
          const arg = params.join('&')
          return "?"+arg
    },
    getmobiletype(){
        var u = navigator.userAgent, app = navigator.appVersion;   
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android终端或者uc浏览器
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        return isAndroid ? "android":"ios"
    },
    toStore(shareSwiper){//去商店
      var downurl = "http://a.app.qq.com/o/simple.jsp?pkgname=com.project.huibinzang&fromcase=40003";
      if(navigator.userAgent.match(/(iPhone|iPod|iPad);?/i))
        {
            var loadDateTime = new Date().getTime();
            window.setTimeout(function() {
                var timeOutDateTime = new Date().getTime();
                if (timeOutDateTime - loadDateTime <4000) {
                    window.location.href = downurl;//下载链接
                } else {
                    window.close();
                }
            },3000);
            window.location.href = shareSwiper.skip;//ios app协议
        }
        if(navigator.userAgent.match(/android/i))
        {
            var loadDateTime = new Date().getTime();
            window.setTimeout(function() {
                var timeOutDateTime = new Date().getTime();
                if (timeOutDateTime - loadDateTime < 4000) {
                    window.location.href = downurl;//下载链接
                } else {
                    window.close();
                }
            },3000);
            window.location.href = shareSwiper.skip;//android app协议
        }       
    },
    IosStore:"http://a.app.qq.com/o/simple.jsp?pkgname=com.project.huibinzang&fromcase=40003",
    AndroidStore:"http://a.app.qq.com/o/simple.jsp?pkgname=com.project.huibinzang&fromcase=40003",
    //自己跳转前缀

    // baseHeaderUrl:"http://192.168.6.45:8768/", //
    
    // 测试环境 ---------------------------------------------------------------

    // ipHeader:"http://192.168.1.210:4000/#",//测试环境
    // baseHeaderUrl:"http://192.168.1.130:8768/", //测试环境
    // baseImgUrl:"http://preh.funeralchain.com",//预发布环境

    
    // 预发布环境 -------------------------------------------------------------

    // ipHeader:"http://preh.funeralchain.com/#",//预发布环境
    // baseHeaderUrl:'http://preapi.funeralchain.com:8768/',//预发布环境
    // baseImgUrl:"http://preh.funeralchain.com",//预发布环境

    // 生产环境 --------------------------------------------------------------

     ipHeader:"http://h.funeralchain.com/#",//生产环境环境
     baseHeaderUrl:'https://api.funeralchain.com:8443/',//生产环境 https ----------
     baseImgUrl:"http://h.funeralchain.com",//生产环境环境
     //  baseHeaderUrl:'http://api.funeralchain.com:8765/',//生产环境

}


// WEBPACK FOOTER //
// ./src/js/global.js